import React from "react";

type PageLoaderProps = {
  message?: string;
  fullScreen?: boolean;
};

const PageLoader: React.FC<PageLoaderProps> = ({
  message = "Loading...",
  fullScreen = true,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center ${
        fullScreen ? "h-screen" : "h-full"
      } w-full bg-gray-100 dark:bg-gray-900 text-gray-700 dark:text-gray-300`}
    >
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-500 mb-4" />
      <p className="text-lg">{message}</p>
    </div>
  );
};

export default PageLoader;
